import { UserCustomRoute } from '../types/CustomRoute';

export const stubbedUserCustomRoute: UserCustomRoute = {
  id: 1,
  _geoloc: {
    lat: 37.7749,
    lng: -122.4194
  },
  activities: ['hiking'],
  activity: {
    uid: 'hiking',
    name: 'Hiking'
  },
  activity_names: ['Hiking'],
  avg_rating: 4.5,
  city_name: 'San Francisco',
  contentPrivacy: 'urn:alltrails:visibility:public',
  country_name: 'USA',
  created_at: '2023-01-01T00:00:00Z',
  updated_at: '2023-01-01T12:00:00Z',
  distance: 10.5,
  duration_minutes: 120,
  elevation_gain: 500,
  estimated_time_to_complete: {
    value: '2',
    unit: 'hours'
  },
  hidden: 0,
  indexed_at: 1672531200,
  length: 10.5,
  missing_polyline: false,
  name: 'Mock Trail',
  objectID: 'mock-object-id',
  photo_count: 3,
  popularity: 100,
  private: false,
  rating: 4.5,
  slug: 'mock-trail',
  state_name: 'California',
  timezone: 'America/Los_Angeles',
  trail_id: 123,
  type: 'map',
  units: 'miles',
  user: {
    id: 42,
    first_name: 'Jane',
    last_name: 'Doe',
    slug: 'jane-doe',
    profile_photo_url: 'https://example.com/photo.jpg'
  }
};
